import { RepresentationType } from '@/graphql';

const representationTypes: { [K in RepresentationType]: string } = {
  [RepresentationType.Solely]: 'Einzelvertretungsberechtigt',
  [RepresentationType.Joint]: 'Gesamtvertretungsberechtigt',
};

export default representationTypes;
